import type { Section, SectionType } from '../model/pages';
import { SelectField } from './InspectorKit';

type On = (patch: Partial<Section>) => void;

/** Only show a control where the renderer can align the content and its
 * accompanying buttons, icons or media. Navigation has its own layout. */
export const SECTION_ALIGNMENT_TYPES: readonly SectionType[] = [
  'hero', 'text', 'benefits', 'compare', 'testimonial', 'image', 'cta', 'form',
  'stats', 'features', 'faq', 'steps', 'logos', 'pricing', 'video', 'gallery',
  'team', 'guarantee', 'split',
];

export function SectionAlignmentField({ section, onChange }: { section: Section; onChange: On }) {
  return (
    <SelectField label={section.type === 'gallery' ? 'Heading alignment' : 'Alignment'} className="[&>select]:!min-h-11" value={section.align ?? ''}
      onChange={(value) => onChange({ align: value ? value as Section['align'] : undefined })}>
      <option value="">Automatic</option>
      <option value="left">Left</option>
      <option value="center">Center</option>
      <option value="right">Right</option>
    </SelectField>
  );
}

export function FooterLayoutFields({ section, onChange }: { section: Section; onChange: On }) {
  return (
    <>
      <SelectField label="Footer layout" className="[&>select]:!min-h-11" value={section.footer_layout ?? ''}
        onChange={(value) => onChange({ footer_layout: value ? value as Section['footer_layout'] : undefined })}>
        <option value="">Automatic</option>
        <option value="row">Row</option>
        <option value="centered">Centered</option>
      </SelectField>
      <SectionAlignmentField section={section} onChange={onChange} />
    </>
  );
}
